import { fantasyEndpoints } from "./fantasy";
import { mediaEndpoints } from "./media";
import { questionsEndpoints } from "./questions";

export const meloukEndpoints = {
    media: mediaEndpoints,
    questions: questionsEndpoints,
    fantasy: fantasyEndpoints,
};